<script setup lang="ts">
import { useHead } from '@unhead/vue';
import Divider from '@/layout/Divider.vue';
import Layout from '@/layout/Layout.vue';

useHead({
  title: "Albano's Villa | Catering",
  meta: [
    {
      name: 'description',
      content:
        "Albano's Villa catering — popular Italian favorites by the pan, from Italian beef and meatballs to mostaccioli. Off-site catering from any location.",
    },
  ],
});
</script>

<template>
  <Layout sidebar="images-catering">
    <h1>Albano's Villa by the Pan</h1>
    <p>
      Let Albano's Villa help make your next party a success. We offer many popular menu items by
      the pan. Contact any of our locations for off-site catering information. On-site catering
      available at our Johnson Road location.
    </p>
    <h2>Italian Beef - ½ Pan</h2>
    <p>
      <span>2 pounds Italian Beef with Au Jus</span>
      <span>2 packages of Italian Bread cut 4 in. or 3 in.</span>
      <span>1 quart Pepperoncinis</span>
      <span>Makes approximately 18-4in. or 20-3in. sandwiches</span>
    </p>
    <h2>Mostaccioli with Cheese - ½ Pan</h2>
    <p>Serves 16-12</p>
    <h2>Meatballs</h2>
    <p>
      <span>2 dozen Meatballs in Spaghetti Sauce</span>
      <span>2 dozen pieces Garlic Bread</span>
    </p>
    <h2>Lasagna - ½ Pan</h2>
    <p>Serves 8-10</p>
    <h2>Tacos - ½ Pan</h2>
    <p>
      Taco Meat with Shredded Lettuce, Diced Tomato, Shredded Cheese & Sour Cream with 40 Taco
      Shells
    </p>
    <h2>Salads</h2>
    <h3>Salad - ½ Pan</h3>
    <p>
      <span>Lettuce, Tomatoes, Onion, Croutons & Choice of Dressing.</span>
      <span>Serves 8-10</span>
    </p>
    <h3>Antipasto Salad - ½ Pan</h3>
    <p>
      <span
        >Lettuce, Italian Capicola Ham, Pepperoni, Salami, Provolone Cheese, Tomatoes & Onion</span
      >
      <span>Pepperoncini, Imported Olives, Croutons &</span>
      <span>Homemade Italian Dressing served on the side.</span>
      <span>Serves 8-10</span>
    </p>
    <Divider />
    <h2>BUFFET/FAMILY-STYLE MENU</h2>
    <h3>Pizza & Pasta Buffet</h3>
    <p>
      <span>Salad Bar with toppings and choice of two dressings</span>
      <span>Baked Mostaccioli with Mozzarella Cheese</span>
      <span>Garlic Bread</span>
      <span>Two Pizzas of your Choice</span>
    </p>
    <h3>Pizza & Italian Beef Buffet</h3>
    <p>
      <span>Salad bar with toppings and choice of two dressings</span>
      <span>Italian Beef with rolls & peppers</span>
      <span>Two Pizzas of your Choice</span>
    </p>
    <h3>Family-Style Dinner</h3>
    <p>
      <span>Salad with choice of two dressings</span>
      <span>Mostaccioli</span>
      <span>Italian Beef with rolls & peppers</span>
      <span>Italian Style Green Beans</span>
      <span>Mashed Potatoes</span>
    </p>
    <Divider />
  </Layout>
</template>
